import { JAWED_HABIB_HAIR_BEAUTY_SALON_KURNOOL_STORE_ID, JAWED_HABIB_HAIR_BEAUTY_SALON_KURNOOL_TENANT_ID, LOOK_WOW_TENANT_ID, ZIRA_STUDIO_SALON_TENANT_ID } from "@constant/common";
import { DEFAULT_DESCRIPTION_METATAG, DEFAULT_IMAGE_METATAG, DEFAULT_KEYWORD_METATAG, DEFAULT_SITENAME_METATAG, DEFAULT_TITLE_METATAG } from "@constant/defaultValues";
import Head from "next/head";

export default function HeadMetaTags({ title, description, image, siteName, storeData }) {

  if (!storeData) storeData = {};
  const titleTagData = title || DEFAULT_TITLE_METATAG;
  const descriptionTagData = description || DEFAULT_DESCRIPTION_METATAG;
  const imageTagData = image || DEFAULT_IMAGE_METATAG;
  const siteNameTagData = siteName || DEFAULT_SITENAME_METATAG;
  const keywordsTagData = descriptionTagData + ' ' + DEFAULT_KEYWORD_METATAG;
  // enable pwa
  // let manifestString: any = '';
  // if (storeData?.configData?.storeConfig?.manifestConfig) {
  //   const theme_color = '';
  //   const manifestConfig = storeData.configData.storeConfig.manifestConfig;
  //   const start_url = manifestConfig.start_url != "/" ? manifestConfig.start_url : ((storeData.host.includes('localhost') ? `http://${storeData.host}${storeData.baseRouteUrl}` : `https://${storeData.host}${storeData.baseRouteUrl}` || '/'))
  //   manifestString = JSON.stringify({
  //     ...{
  //       "name": `${manifestConfig.name}` || 'Respark',
  //       "short_name": manifestConfig.short_name || `${storeData.tenant}` || 'Respark',
  //       "start_url": start_url,
  //       "scope": start_url,
  //       "display": "standalone",
  //       "background_color": manifestConfig.background_color || theme_color || "#dee1ec",
  //       "theme_color": manifestConfig.theme_color || theme_color || "#dee1ec",
  //       "orientation": "portrait",
  //       "description": manifestConfig.description || storeData.description,
  //       "id": storeData.tenantId,
  //       "icons": [
  //         {
  //           "src": manifestConfig.icons['180'],
  //           "type": "image/png",
  //           "sizes": "180x180"
  //         },
  //         {
  //           "src": manifestConfig.icons['192'],
  //           "type": "image/png",
  //           "sizes": "192x192"
  //         },
  //         {
  //           "src": manifestConfig.icons['384'],
  //           "type": "image/png",
  //           "sizes": "384x384"
  //         },
  //         {
  //           "src": manifestConfig.icons['512'],
  //           "type": "image/png",
  //           "sizes": "512x512"
  //         },
  //         {
  //           "src": manifestConfig.icons['1024'],
  //           "type": "image/png",
  //           "sizes": "1024x1024"
  //         }
  //       ],
  //       "related_applications": [{
  //         "platform": "webapp",
  //         "url": storeData.host.includes('localhost') ? `http://${storeData.host}/manifest.json` : `https://${storeData.host}/manifest.json`
  //       }]
  //     },
  //   });
  // }
  // enable pwa

  return (
    <Head>
      {/* // enable pwa */}
      {/* <link rel="manifest" id="manifest" href={`data:application/json;charset=utf-8,${encodeURIComponent(manifestString)}`} /> */}
      {/* // enable pwa */}

      {/* Coomon meta tags */}
      <title>{titleTagData}</title>
      <meta name="title" key="title" content={titleTagData} />
      <meta name="description" key="description" content={descriptionTagData} />
      <meta name="keywords" key="keywords" content={keywordsTagData} />
      <meta name="robots" content="noindex, nofollow" />
      <meta name="application-name" content="Respark" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="default" />
      <meta name="apple-mobile-web-app-title" content="Respark" />
      <meta name="description" content="Best Respark in the world" />
      <meta name="format-detection" content="telephone=no" />
      <meta name="mobile-web-app-capable" content="yes" />

      {/* FB meta Tags */}
      {/* <meta property="og:url" content='www.devourin.com' key="ogurl" /> */}
      <meta property="og:site_name" content={siteNameTagData} key="ogsitename" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={titleTagData} key="ogtitle" />
      <meta property="og:description" content={descriptionTagData} key="ogdesc" />
      <meta property="og:image" content={imageTagData} key="ogimage" />

      {/* Twitter meta Tags */}
      <meta name="twitter:title" content={titleTagData} key="twittertitle" />
      <meta name="twitter:description" content={descriptionTagData} key="twitterdesc" />
      <meta name="twitter:image" content={imageTagData} key="twitterimage" />
      <meta name="twitter:site" content="Devourin Salon" key="twittersitename" />
      <meta name="twitter:creator" content="Devourin" />
      {/* application meta tags */}

      {/* <meta name="viewport" content="width=device-width,initial-scale=1" /> */}
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" />
      <meta name="robots" content="noindex, nofollow" />
      <link rel="shortcut icon" type="image/png" href="/favicon.ico" />

      {/* //added gatg for look wow */}
      {Number(storeData?.tenantId) == LOOK_WOW_TENANT_ID && <>
        <script async src="https://www.googletagmanager.com/gtag/js?id=AW-16565257530"></script>
        <script async custom-element="amp-analytics" src="https://cdn.ampproject.org/v0/amp-analytics-0.1.js"></script>
        <script
          dangerouslySetInnerHTML={{
            __html: `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'AW-16565257530');`
          }}
        />
      </>}
      {/* //added gatg for look wow */}

      {/* //added gatg for zira */}
      {Number(storeData?.tenantId) == ZIRA_STUDIO_SALON_TENANT_ID && <>
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-3QWD5G9E48"></script>
        <script async custom-element="amp-analytics" src="https://cdn.ampproject.org/v0/amp-analytics-0.1.js"></script>
        <script
          dangerouslySetInnerHTML={{
            __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-3QWD5G9E48');`
          }}
        />
      </>}
      {/* //added gatg for zira */}

      {/* <!-- Meta Pixel Code --> */}
      {(Number(storeData?.tenantId) === JAWED_HABIB_HAIR_BEAUTY_SALON_KURNOOL_TENANT_ID) &&
        (Number(storeData?.storeId) === JAWED_HABIB_HAIR_BEAUTY_SALON_KURNOOL_STORE_ID) && (
          <>
            <script
              dangerouslySetInnerHTML={{
                __html: `
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '716407874150684');
          fbq('track', 'PageView');
        `
              }}
            />
            <noscript dangerouslySetInnerHTML={{
              __html: `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=716407874150684&ev=PageView&noscript=1" />`
            }} />
          </>
        )}

      {/* <!-- End Meta Pixel Code --> */}
    </Head>
  );
}
